import type { OverviewResponse } from "contracts/api/dashboard/responses";

export type Page = OverviewResponse["pages"][number];
export type Link = OverviewResponse["links"][number];

export type EstateNode = {
  page: Page;
  x: number;
  y: number;
  width: number;
  height: number;
  cluster: string;
  important: boolean;
  issueCount: number;
  score: number | null;
  state: string;
};

export type EstateBand = {
  key: string;
  label: string;
  x: number;
  y: number;
  width: number;
  height: number;
  pageCount: number;
  representedPageCount: number;
  averageScore: number | null;
  weakPages: number;
  importantPages: number;
};

export type EstateLayout = {
  nodes: EstateNode[];
  bands: EstateBand[];
  width: number;
  height: number;
  viewport: EstateViewport;
};

export type EstateEdge = {
  key: string;
  link: Link;
  from: EstateNode;
  to: EstateNode;
};

export type EstateClusterEdge = {
  key: string;
  from: EstateBand;
  to: EstateBand;
  count: number;
  brokenCount: number;
};

export type ViewTransform = {
  x: number;
  y: number;
  scale: number;
};

export type EstateViewport = {
  width: number;
  height: number;
};

export const SUMMARY_VIEWPORT: EstateViewport = { width: 128, height: 58 };
export const PAGES_VIEWPORT: EstateViewport = { width: 128, height: 68 };
export const SUMMARY_NODE_WIDTH = 20.5;
export const SUMMARY_NODE_HEIGHT = 8.5;
export const PAGE_NODE_WIDTH = 20.5;
export const PAGE_NODE_HEIGHT = 9.2;
export const CLUSTER_HEADER_HEIGHT = 7;
export const CLUSTER_PADDING = 2.2;
export const CLUSTER_COLUMN_GAP = 2;
export const CLUSTER_ROW_GAP = 2;
export const CLUSTER_LAYER_GAP = 5;
export const CLUSTER_MARGIN = 3;
export const PAN_BOUNDS_PADDING = 4;
export const MAX_ZOOM = 2.7;
export const FULL_FIT_MAX_ZOOM = 1.08;
export const TOOLTIP_WIDTH = 260;
export const TOOLTIP_HEIGHT = 152;
export const TOOLTIP_MARGIN = 12;
export const TOOLTIP_EDGE_MARGIN = 12;
